// src/app/pages/dashboard/dashboard.component.ts
import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';

import { StatsCardComponent } from './components/stat-card/stat-card.component';
import { AnalysisComponent } from './components/analysis/analysis.component';
import { DashboardCostmetricsComponent } from './components/dashboard-costmetrics/dashboard-costmetrics';

import { ConditionStore } from '../../core/shared/condition.store';
import { AnalysisStore } from '../../core/shared/analysis.store';
import { YearStore } from '../../core/shared/year.store';

@Component({
    selector: 'app-dashboard',
    standalone: true,
    imports: [CommonModule, StatsCardComponent, AnalysisComponent, DashboardCostmetricsComponent],
    templateUrl: './dashboard.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Dashboard {
    private conditionStore = inject(ConditionStore);
    private analysisStore = inject(AnalysisStore);
    private yearStore = inject(YearStore);
    private http = inject(HttpClient);

    condition$ = this.conditionStore.getCondition$();

    latestRunHtn: Record<string, Record<string, number>> | null = null;
    latestRunRows: Array<any> | null = null;
    latestRunIndex: number | null = null;

    yearOverride: string | null = null;

    constructor() { }

    ngOnInit(): void {
        // Health check now runs once at login (see Login component +
        // HealthCheckService) rather than on every Dashboard visit.

        // 1. Initial response seeding
        this.http.get<any>('assets/initial-response.json').subscribe({
            next: (resp) => {
                const initialHtn = resp?.htn ?? null;
                if (!this.analysisStore.hasRuns()) {
                    this.latestRunIndex = 0;
                    this.latestRunHtn = initialHtn ? { ...initialHtn } : null;
                    const rows = Array.isArray(resp?.rows) ? resp.rows : [];
                    this.latestRunRows = rows.length ? [...rows] : null;
                }
            },
            error: (err) => {
                console.error('[DASHBOARD] /assets/initial-response.json error:', err);
            },
        });

        // 2. Runs subscription
        this.analysisStore.runsList$.subscribe((runs) => {
            if (runs.length) {
                this.latestRunIndex = runs.length - 1;
                const run = runs[this.latestRunIndex];
                this.latestRunHtn = run?.htn ? { ...run.htn } : null;
                this.latestRunRows = run?.rows ? [...run.rows] : null;
            } else {
                this.latestRunIndex = 0;
                this.latestRunHtn = this.latestRunHtn ?? null;
                this.latestRunRows = this.latestRunRows ?? null;
            }
        });

        // 3. Year subscription
        this.yearStore.year$.subscribe((y) => {
            this.yearOverride = y != null ? String(y) : null;
        });
    }
}